import React from 'react';
interface TextRollProps {
  label: string;
  className?: string;
}

// Duplicate-label roll effect. The parent link needs the `roll-link` class.
// The rolling duplicate is drawn with a CSS pseudo-element (content: attr(data-label)),
// so the label exists only once in the page text — no "Ask us a questionAsk us a question"
// when copying, selecting, or reading it with a screen reader.
export function TextRoll({
  label,
  className = ''
}: TextRollProps) {
  return <span className={`relative block overflow-hidden [perspective:400px] ${className}`} data-id="element-200" data-mp="1zq1j38pypkev">
      <span className="roll-1 block py-[0.125em]" data-label={label} data-id="element-201" data-mp="1urhs2twihifn">
        {label}
      </span>
    </span>;
}